import { render, staticRenderFns } from "./CompensacoesHistorico.vue?vue&type=template&id=2d5c3ba6"
import script from "./CompensacoesHistorico.vue?vue&type=script&lang=js"
export * from "./CompensacoesHistorico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports